import React, { useState } from "react";
import { db, auth } from "../service/firebase";
import { Avatar } from "@material-ui/core";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// function usePrevious(name) {
//   const ref = useRef();
//   useEffect(() => {
//     ref.current = name;
//   });
//   return ref.current;
// }

function UserProfile({ username, profilePic }) {
  const [userProfile, setUserProfile] = useState({});

  const openUserDetails = () => {
    db.collection("users")
      .doc(username)
      .get()
      .then((doc) => {
        setUserProfile(doc.data());
      });
  };

  const [bio, setBio] = useState("");
  const [edit, setEdit] = useState(false);

  const editField = () => {
    setEdit(true);
  };

  const sendEmailVerification = () => {
    auth.currentUser.sendEmailVerification().then(() => {
      toast.info("email verification is send to your email");
    });
  };

  const saveBioBtn = () => {
    db.collection("users")
      .doc(username)
      .update({
        bio: bio,
      })
      .then(() => {
        setEdit(false);
      });
  };

  return (
    <div className="d-flex align-items-center flex-column">
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        closeOnClick
        draggable
        pauseOnFocusLoss
        pauseOnHover
      />
      <h3>Profile</h3>
      <div className="d-flex align-items-center m-2 border p-2">
        <Avatar alt="" src={profilePic} />
        <strong>{username}</strong>
      </div>

      <div className="col-md-6">
        <div className=" d-flex align-items-center justify-content-around">
          <button
            className="btn btn-primary mb-3"
            type="button"
            onClick={sendEmailVerification}
            disabled={auth?.currentUser?.emailVerified}
          >
            send Email verification
          </button>
        </div>
      </div>

      <button
        className="btn btn-primary mb-3"
        type="button"
        data-toggle="collapse"
        data-target="#collapseExample"
        aria-expanded="false"
        aria-controls="collapseExample"
        onClick={openUserDetails}
      >
        See Profile
      </button>

      <div className="collapse col-md-6 mb-5" id="collapseExample">
        <div className="input-group mb-3  input-group-sm">
          <div className="input-group-prepend">
            <span className="input-group-text" id="input-username">
              <strong>Username</strong>
            </span>
          </div>
          <input
            type="text"
            className="form-control"
            aria-label="Username"
            aria-describedby="input-username"
            value={userProfile.user}
            disabled
          />
        </div>
        <div className="input-group mb-3  input-group-sm">
          <div className="input-group-prepend">
            <span className="input-group-text" id="input-email">
              <strong>Email</strong>
            </span>
          </div>
          <input
            type="text"
            className="form-control"
            aria-label="email"
            aria-describedby="input-email"
            value={userProfile.email}
            disabled
          />
        </div>
        <div className="input-group mb-3  input-group-sm">
          <div className="input-group-prepend">
            <span className="input-group-text" id="input-gender">
              <strong>Gender</strong>
            </span>
          </div>
          <input
            type="text"
            className="form-control"
            aria-label="gender"
            aria-describedby="input-gender"
            value={userProfile.gender}
            disabled
          />
        </div>
        <div className="input-group mb-3  input-group-sm">
          <div className="input-group-prepend">
            <span className="input-group-text" id="input-Fullname">
              <strong>Fullname</strong>
            </span>
          </div>
          <input
            type="text"
            className="form-control"
            aria-label="Fullname"
            aria-describedby="input-Fullname"
            disabled
            value={userProfile.fullname}
          />
        </div>
        <div className="input-group mb-3  input-group-sm">
          <div className="input-group-prepend">
            <span className="input-group-text" id="input-dob">
              <strong>Dob</strong>
            </span>
          </div>
          <input
            type="date"
            className="form-control"
            aria-label="dob"
            aria-describedby="input-dob"
            disabled
            value={userProfile.dob}
          />
        </div>
        <div className="input-group mb-3  input-group-sm">
          <div className="input-group-prepend">
            <span className="input-group-text" id="input-bio">
              <strong>Bio</strong>
            </span>
          </div>
          <textarea
            className="form-control"
            aria-label="With textarea"
            disabled
            value={userProfile.bio}
          />
          <textarea
            className="form-control"
            aria-label="With textarea"
            placeholder="enter you bio"
            disabled={!edit}
            value={bio}
            onChange={(e) => setBio(e.target.value)}
          />
        </div>
        <div className=" d-flex align-items-center justify-content-around mb-3">
          <button className="btn btn-primary " onClick={editField}>
            Edit Bio
          </button>
          <button className="btn btn-success " onClick={saveBioBtn}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserProfile;
